import { getLocale } from "../runtime";

const sv_iconback = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tillbaka`
};

const iconback = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconback(inputs)
	return "iconBack";
};

export { iconback as "iconBack" };